import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import menuHelper from '@appbase/util/menu-helper'
import GnbItemSubItem from '@gnb/components/GlobalNavigationBarLeft/GnbItemSubItem.vue'

@Component({
    components: { GnbItemSubItem }
})
export default class GnbIUtemSub extends Vue {
    @Prop({type: Array}) menuItems!: appbase.cache.TMenuItem[]
    @Prop({type:String}) topMenuName!: string
    @Prop({type:String}) userLang!: string
    selMenuId: number = 0;

    fnExpandItem(item: appbase.cache.TMenuItem){
        let iObj = document.getElementById('i_GnbItem_' + item.menuId)
        let subObj = document.getElementById('div_GnbItem_sub_' + item.menuId)

        if (iObj) {
            if (iObj.classList.contains('icon-fux-minus-square')) {
                iObj.classList.remove('icon-fux-minus-square')
                iObj.classList.add('icon-fux-add-square')
                subObj?.setAttribute('style', 'display:none')
            } else {
                iObj.classList.remove('icon-fux-add-square')
                iObj.classList.add('icon-fux-minus-square')
                subObj?.removeAttribute('style')
            }
        }
    }

    fnMenuClick(item: appbase.cache.TMenuItem){
        if (item && item.targetUrl == '' && item.hasChildren){
            this.fnExpandItem(item);
        }
        else{
            this.$emit('onMenuClick', item);
        }
    }

    created()
    {
        if (this.$route.query.MENUID){
            let menuId = Number(this.$route.query.MENUID)
            let subMenuId: number = menuHelper.getSubMenuId(menuId);
            if (subMenuId != 0)
            {
                this.selMenuId = subMenuId;
            }
        }
    }
}